import { render, staticRenderFns } from "./sharingGuide.vue?vue&type=template&id=27c6608a&scoped=true&"
import script from "./sharingGuide.vue?vue&type=script&lang=js&"
export * from "./sharingGuide.vue?vue&type=script&lang=js&"
import style0 from "./sharingGuide.vue?vue&type=style&index=0&id=27c6608a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c6608a",
  null
  
)

export default component.exports